import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { Box, Typography, TextField, MenuItem, Select, InputLabel, Autocomplete, CircularProgress } from "@mui/material";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import style from "./style";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LoadingButton } from "@mui/lab";
import { CustomizedRadio } from "../../../../components/CustomRadio";
import dayjs from "dayjs";


const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 32,
  height: 18,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(12px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(14px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#28AA4A",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 14,
    height: 14,
    borderRadius: 7,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 18 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark" ? "rgba(255,255,255,.35)" : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const Report = ({ departmentData, deductionType, pensionType, leviesType, handleEmployeeReport, handleEmployee, loading, employeeData, handlePayslipReport, handleEmpPayslipReport, handleLeviesReport, handleDeductionReport,
  handlePensionReport, handleFringeReport, handleCreditReport, handleLoanReport, handleUifReport, handleSdlReport, handlePayeReport, fringeData, handleAttendanceReport, creditsType, handleGeneralizeTax, payeName }) => {
  const payeLabel = payeName || "PAYE";
  const role = localStorage.getItem("role");
  const isEmployeeRole = role === "Employee" || role === "employee";
  const radioLabelPayment = [{ label: "All", value: "all" }, { label: "Cash", value: "Cash" }, { label: "Cheque", value: "Cheque" }, { label: "Transfer", value: "Transfer" },]
  const handleEmployees = (value) => {
    handleEmployee(value);
  }
  const [optionValue, setOptionValue] = useState("");
  const [employeeStatus, setEmployeeStatus] = useState("");
  const [costCente, setcostCente] = useState("");
  const [empId, setEmpId] = useState("");
  const [date, setDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [payslipcostCente, setPayslipCostCente] = useState();
  const [payment, setPayment] = useState();
  const [empFrom, setEmpFrom] = useState();
  const [empTo, setEmpTo] = useState();
  const [levyFrom, setLevyFrom] = useState();
  const [levyTo, setLevyTo] = useState();
  const [levy, setLevy] = useState();
  const [levyEmail, setLevyEmail] = useState();
  const [deductionFrom, setDeductionFrom] = useState();
  const [deductionTo, setDeductionTo] = useState();
  const [deduction, setDeduction] = useState();
  const [deductionEmail, setDeductionEmail] = useState();
  const [pensionFrom, setPensionFrom] = useState();
  const [pensionTo, setPensionTo] = useState();
  const [pension, setPension] = useState();
  const [fringeFrom, setFringeFrom] = useState();
  const [fringeTo, setFringeTo] = useState();
  const [fringe, setFringe] = useState();
  const [creditFrom, setCreditForm] = useState();
  const [creditTo, setCreditTo] = useState();
  const [credit, setCredit] = useState();
  const [loanFrom, setLoanFrom] = useState();
  const [loanTo, setLoanTo] = useState();
  const [payeFrom, setPayeFrom] = useState();
  const [payeTo, setPayeTo] = useState();
  const [attendanceFrom, setAttendanceFrom] = useState();
  const [attendanceTo, setAttendanceTo] = useState();
  const [includeAllEmployees, setIncludeAllEmployees] = useState(false);
  const [sdlFrom, setSdlFrom] = useState();
  const [sdlTo, setSdlTo] = useState();
  const [uifFrom, setUifFrom] = useState();
  const [uifTo, setUifTo] = useState();
  const [reportType, setReportType] = useState("Employees List Report");
  const [generalStartDate, setGeneralStartDate] = useState(dayjs());
  const [generalEndDate, setGeneralEndDate] = useState(dayjs());
  const [deductionCostCente, setDeductionCostCente] = useState("");
  const [filterDepartment, setFilterDepartment] = useState("");
  const [filterRateType, setFilterRateType] = useState("");
  const bulkFilters = { department: filterDepartment, rateType: filterRateType };

  const renderBulkFilters = () => (
    <>
      <Grid item xs={12} lg={4}>
        <Box sx={style.inputSection}>
          <InputLabel sx={style.labels}>Cost Centres</InputLabel>
          <Box sx={style.selectGrid}>
            <Select
              value={filterDepartment}
              onChange={(e) => setFilterDepartment(e.target.value)}
              name="filterDepartment"
              sx={style.modalInput}
              displayEmpty>
              <MenuItem value="" sx={style.dropDownMenu}>All</MenuItem>
              {departmentData?.map((item, index) => (
                <MenuItem key={index} sx={style.dropDownMenu} value={item?.name}>{item?.name}</MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} lg={4}>
        <Box sx={style.inputSection}>
          <InputLabel sx={style.labels}>Rate Type</InputLabel>
          <Box sx={style.selectGrid}>
            <Select
              value={filterRateType}
              onChange={(e) => setFilterRateType(e.target.value)}
              name="filterRateType"
              sx={style.modalInput}
              displayEmpty>
              <MenuItem value="" sx={style.dropDownMenu}>All</MenuItem>
              <MenuItem value="Hourly" sx={style.dropDownMenu}>Hourly</MenuItem>
              <MenuItem value="Salary" sx={style.dropDownMenu}>Salary</MenuItem>
            </Select>
          </Box>
        </Box>
      </Grid>
    </>
  );

  return (
    <>
      <Box sx={style.reportGrid}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>{isEmployeeRole ? "My Reports" : "Reports"}</Typography>
        </Box>
        <Box sx={style.containerRight}>
          <Select
            value={reportType}
            onChange={(e) => {
              setReportType(e.target.value);
              setFilterDepartment("");
              setFilterRateType("");
            }}
            name="employeeStatus"
            sx={style.modalInputReport}
            displayEmpty>
            <MenuItem disabled value="">
              General Reports
            </MenuItem>
            <MenuItem sx={style.dropDownMenu} value="Employees List Report">Employees List Report</MenuItem>
            <MenuItem sx={style.dropDownMenu} value="List Payslips">List Payslips</MenuItem>
            <MenuItem sx={style.dropDownMenu} value="Payslips By Employee">Payslips By Employee</MenuItem>
            <MenuItem sx={style.dropDownMenu} value="Employer Levies List">Employee Levies List</MenuItem>
            <MenuItem sx={style.dropDownMenu} value="Deductions List">Deductions List</MenuItem>
            <MenuItem sx={style.dropDownMenu} value="Fringes Report">Fringes Report</MenuItem>
            <MenuItem sx={style.dropDownMenu} value="Credit Report">Credit Report</MenuItem>
            <MenuItem sx={style.dropDownMenu} value="Loan Report">Loan Report</MenuItem>
            <MenuItem sx={style.dropDownMenu} value="Attendance Report">Attendance Report</MenuItem>
            <MenuItem disabled value="">
              Legislative Reports
            </MenuItem>
            <MenuItem sx={style.dropDownMenu} value="PAYE Report">{payeLabel} Report</MenuItem>
            {/* <MenuItem sx={style.dropDownMenu} value="SDL Report">SDL Report</MenuItem> */}
            {/* <MenuItem sx={style.dropDownMenu} value="UIF Report">UIF Report</MenuItem> */}
            <MenuItem sx={style.dropDownMenu} value="Generalize Tax Report">Generalize Tax Report</MenuItem>
          </Select>
        </Box>
      </Box>
      {reportType === "Employees List Report" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>Employees List Report</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>Employee Status</InputLabel>
                    <Box sx={style.selectGrid}>
                      <Select
                        value={employeeStatus}
                        onChange={(e) => setEmployeeStatus(e.target.value)}
                        name="employeeStatus"
                        sx={style.modalInput}
                        displayEmpty>
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>
                        <MenuItem sx={style.dropDownMenu} value="true">Active</MenuItem>
                        <MenuItem sx={style.dropDownMenu} value="false">Inactive</MenuItem>
                        <MenuItem sx={style.dropDownMenu} value="deleted">Deleted</MenuItem>
                      </Select>
                    </Box>

                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>

                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>Cost Centres</InputLabel>

                    <Box sx={style.selectGrid}>
                      <Select
                        value={costCente}
                        onChange={(e) => {
                          setcostCente(e.target.value)
                          if (costCente === "all") {
                            setEmpId("")
                          }
                        }}
                        name="type"
                        sx={style.modalInput}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>
                        <MenuItem value="all" sx={style.dropDownMenu}>All</MenuItem>

                        {departmentData?.map((item, index) => (

                          <MenuItem key={index} sx={style.dropDownMenu} value={item?.name}>{item?.name}</MenuItem>
                        ))}
                      </Select>
                    </Box>

                  </Box>
                </Grid>
                {costCente !== "all" && (

                  <Grid item xs={12} lg={4}>

                    <Box sx={style.inputSection}>
                      <InputLabel sx={style.labels}>Staff Id</InputLabel>


                      <Box sx={style.selectGrid}>
                        <TextField sx={style.modalInputs}
                          value={empId}
                          onChange={(e) => setEmpId(e.target.value)}
                          placeholder="Enter Staff ID"
                          name="type"
                          disabled={costCente === "all"} // Disable logic

                        >
                        </TextField>
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!employeeStatus || !costCente}
                  onClick={() => handleEmployeeReport(employeeStatus, costCente, empId, "pdf")}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  onClick={() => handleEmployeeReport(employeeStatus, costCente, empId, "csv")}
                  disabled={!employeeStatus || !costCente}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>
              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!employeeStatus || !costCente}
                  onClick={() => handleEmployeeReport(employeeStatus, costCente, empId, "excel")}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>
              </Box>
            </Box>
          </Grid>
        </>
      )}
      {reportType === "List Payslips" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>List Payslips</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>

                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={date}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setDate(newValue); }}
                        />
                      </Box>
                    </LocalizationProvider>
                  </Box>

                </Grid>
                <Grid item xs={12} lg={4}>

                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={toDate}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setToDate(newValue); }}
                          minDate={date}
                        />
                      </Box>
                    </LocalizationProvider>

                  </Box>

                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>Cost Centre</InputLabel>

                    <Box sx={style.selectGrid}>
                      <Select
                        value={payslipcostCente}
                        onChange={(e) => setPayslipCostCente(e.target.value)}
                        name="type"
                        sx={style.modalInput}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>
                        <MenuItem value="all" sx={style.dropDownMenu}>All</MenuItem>

                        {departmentData?.map((item, index) => (

                          <MenuItem key={index} sx={style.dropDownMenu} value={item?.name}>{item?.name}</MenuItem>
                        ))}
                      </Select>
                    </Box>

                  </Box>
                </Grid>
              </Grid>
              <Grid container sx={style.gridContainer}>
                <Grid item xs={12} lg={6}>

                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>Payment Method</InputLabel>

                    <CustomizedRadio handleChange={(value) => setPayment(value)}
                      value={payment} defaultChecked={payment} radioLabel={radioLabelPayment} />

                  </Box>
                </Grid>
                {/* <Grid item xs={12} lg={6}>

                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>Frequency</InputLabel>

                    <CustomizedRadio handleChange={(value) => setFrequency(value)}
                      value={frequency} defaultChecked={frequency} radioLabel={radioLabel} />
                  </Box>
                </Grid> */}
              </Grid>




            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"

                  onClick={() => handlePayslipReport(payment, payslipcostCente, dayjs(date).format("YYYY-MM-DD"), dayjs(toDate).format("YYYY-MM-DD"), "pdf")}
                  disabled={!payment || !payslipcostCente || !date || !toDate}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  onClick={() => handlePayslipReport(payment, payslipcostCente, dayjs(date).format("YYYY-MM-DD"), dayjs(toDate).format("YYYY-MM-DD"), "csv")}
                  type="submit"
                  color="primary"
                  disabled={!payment || !payslipcostCente || !date || !toDate}

                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>


              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!payment || !payslipcostCente || !date || !toDate}
                  onClick={() => handlePayslipReport(payment, payslipcostCente, dayjs(date).format("YYYY-MM-DD"), dayjs(toDate).format("YYYY-MM-DD"), "excel")}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>


              </Box>

            </Box>
          </Grid>
        </>
      )}

      {reportType === "Payslips By Employee" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>Payslips By Employee</Typography>

          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>

                  <Box sx={style.inputSection}>
                    <Autocomplete
                      id="autocomplete"
                      options={employeeData || []}
                      getOptionLabel={(option) => option?.personalInfo?.email}
                      onInputChange={(event, newInputValue) => {
                        handleEmployees(newInputValue);
                      }}

                      onChange={(event, newValue) => {
                        setOptionValue(newValue?.personalInfo?.email);
                        // setEmployeeId(newValue?._id)
                      }}

                      renderInput={(params) => (
                        <><InputLabel sx={style.label}>{"Employee Email"}</InputLabel><TextField
                          {...params}
                          sx={{ ...style.modalInput, ...style.inputSpace }}

                          // label="Search Employee"
                          variant="outlined"
                          // value={change ? optionValue : item?.employeeDetails?.personalInfo.email || ""}

                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }} /></>
                      )}
                    />
                  </Box>

                </Grid>
                <Grid item xs={12} lg={4}>

                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={empFrom}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setEmpFrom(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>

                </Grid>
                <Grid item xs={12} lg={4}>

                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={empTo}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setEmpTo(newValue); }}
                          minDate={empFrom}
                        />
                      </Box>
                    </LocalizationProvider>

                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!optionValue || !empFrom || !empTo}
                  onClick={() => handleEmpPayslipReport(optionValue, dayjs(empFrom).format("YYYY-MM-DD"), dayjs(empTo).format("YYYY-MM-DD"), "pdf")}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!optionValue || !empFrom || !empTo}
                  onClick={() => handleEmpPayslipReport(optionValue, dayjs(empFrom).format("YYYY-MM-DD"), dayjs(empTo).format("YYYY-MM-DD"), "csv")}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>
              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!optionValue || !empFrom || !empTo}
                  onClick={() => handleEmpPayslipReport(optionValue, dayjs(empFrom).format("YYYY-MM-DD"), dayjs(empTo).format("YYYY-MM-DD"), "excel")}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>
              </Box>
            </Box>
          </Grid>
        </>
      )}
      {reportType === "Employer Levies List" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>Employer Levies List</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>

                <Grid item xs={12} lg={4}>

                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={levyFrom}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setLevyFrom(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>

                </Grid>
                <Grid item xs={12} lg={4}>

                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={levyTo}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setLevyTo(newValue); }}
                          minDate={levyFrom}
                        />
                      </Box>
                    </LocalizationProvider>

                  </Box>

                </Grid>
                <Grid item xs={12} lg={4}>

                  <Box sx={style.inputSection}>
                    <Autocomplete
                      id="autocomplete"
                      options={employeeData || []}
                      getOptionLabel={(option) => option?.personalInfo?.email}
                      onInputChange={(event, newInputValue) => {
                        handleEmployees(newInputValue);
                      }}

                      onChange={(event, newValue) => {
                        setLevyEmail(newValue?.personalInfo?.email);
                      }}

                      renderInput={(params) => (
                        <><InputLabel sx={style.label}>{"Employee Email"}</InputLabel><TextField
                          {...params}
                          sx={{ ...style.modalInput, ...style.inputSpace }}

                          // label="Search Employee"
                          variant="outlined"
                          // value={change ? optionValue : item?.employeeDetails?.personalInfo.email || ""}

                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }} /></>
                      )}
                    />
                  </Box>
                </Grid>
              </Grid>
              <Grid container>
                {!isEmployeeRole && renderBulkFilters()}
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>Levy</InputLabel>
                    <Box sx={style.selectGrid}>
                      <Select
                        value={levy}
                        onChange={(e) => { setLevy(e.target.value) }}
                        name="type"
                        sx={style.modalInput}
                        displayEmpty>
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>
                        <MenuItem sx={style.dropDownMenu} value="all">All</MenuItem>

                        {leviesType?.map((item, index) => (
                          <MenuItem key={index} sx={style.dropDownMenu} value={item?.name}>{item?.name}</MenuItem>
                        ))}
                      </Select>
                    </Box>

                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!levyFrom || !levyTo || !levy}
                  onClick={() => handleLeviesReport(levyEmail, dayjs(levyFrom).format("YYYY-MM-DD"), dayjs(levyTo).format("YYYY-MM-DD"), levy, "pdf", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>


              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!levyFrom || !levyTo || !levy}
                  onClick={() => handleLeviesReport(levyEmail, dayjs(levyFrom).format("YYYY-MM-DD"), dayjs(levyTo).format("YYYY-MM-DD"), levy, "csv", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>
              </Box>

              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!levyFrom || !levyTo || !levy}
                  onClick={() => handleLeviesReport(levyEmail, dayjs(levyFrom).format("YYYY-MM-DD"), dayjs(levyTo).format("YYYY-MM-DD"), levy, "excel", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>


              </Box>

            </Box>
          </Grid>
        </>
      )}
      {reportType === "Deductions List" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>Deductions List</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={deductionFrom}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setDeductionFrom(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>

                </Grid>
                <Grid item xs={12} lg={4}>

                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={deductionTo}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setDeductionTo(newValue); }}
                          minDate={deductionFrom}
                        />
                      </Box>
                    </LocalizationProvider>

                  </Box>

                </Grid>
                {/* <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <Autocomplete
                      id="autocomplete"
                      options={employeeData || []}
                      getOptionLabel={(option) => option?.personalInfo?.email}
                      onInputChange={(event, newInputValue) => {
                        handleEmployees(newInputValue);
                      }}

                      onChange={(event, newValue) => {
                        setDeductionEmail(newValue?.personalInfo?.email);
                        // setEmployeeId(newValue?._id)
                      }}

                      renderInput={(params) => (
                        <><InputLabel sx={style.label}>{"Employee Email"}</InputLabel><TextField
                          {...params}
                          sx={{ ...style.modalInput, ...style.inputSpace }}

                          // label="Search Employee"
                          variant="outlined"
                          // value={change ? optionValue : item?.employeeDetails?.personalInfo.email || ""}

                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }} /></>
                      )}
                    />
                  </Box>
                </Grid> */}
                <Grid item xs={12} lg={4}>

                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>Cost Centres</InputLabel>

                    <Box sx={style.selectGrid}>
                      <Select
                        value={deductionCostCente}
                        onChange={(e) => {
                          setDeductionCostCente(e.target.value)
                          if (deductionCostCente === "all") {
                            setDeductionEmail("")
                          }
                        }}
                        name="type"
                        sx={style.modalInput}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>
                        <MenuItem value="all" sx={style.dropDownMenu}>All</MenuItem>

                        {departmentData?.map((item, index) => (

                          <MenuItem key={index} sx={style.dropDownMenu} value={item?.name}>{item?.name}</MenuItem>
                        ))}
                      </Select>
                    </Box>

                  </Box>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>Deduction</InputLabel>
                    <Box sx={style.selectGrid}>
                      <Select
                        value={deduction}
                        onChange={(e) => { setDeduction(e.target.value) }}
                        name="type"
                        sx={style.modalInput}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                          Select
                        </MenuItem>
                        <MenuItem sx={style.dropDownMenu} value="all">All</MenuItem>

                        {deductionType?.map((item, index) => (

                          <MenuItem key={index} sx={style.dropDownMenu} value={item?.name}>{item?.name}</MenuItem>
                        ))}
                      </Select>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!deductionCostCente || !deductionFrom || !deductionTo || !deduction}
                  onClick={() => handleDeductionReport(deduction, dayjs(deductionFrom).format("YYYY-MM-DD"), dayjs(deductionTo).format("YYYY-MM-DD"), deductionCostCente, "pdf")}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!deductionCostCente || !deductionFrom || !deductionTo || !deduction}
                  onClick={() => handleDeductionReport(deduction, dayjs(deductionFrom).format("YYYY-MM-DD"), dayjs(deductionTo).format("YYYY-MM-DD"), deductionCostCente, "csv")}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>
              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!deductionCostCente || !deductionFrom || !deductionTo || !deduction}
                  onClick={() => handleDeductionReport(deduction, dayjs(deductionFrom).format("YYYY-MM-DD"), dayjs(deductionTo).format("YYYY-MM-DD"), deductionCostCente, "excel")}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>
              </Box>
            </Box>
          </Grid>
        </>
      )}

      {reportType === "Fringes Report" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>Fringes Report</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={fringeFrom}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setFringeFrom(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={fringeTo}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setFringeTo(newValue); }}
                          minDate={fringeFrom}
                        />
                      </Box>
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>Fringe</InputLabel>
                    <Box sx={style.selectGrid}>
                      <Select
                        value={fringe}
                        onChange={(e) => { setFringe(e.target.value) }}
                        name="type"
                        sx={style.modalInput}
                        displayEmpty>
                        <MenuItem disabled value=""> Select </MenuItem>
                        <MenuItem sx={style.dropDownMenu} value="all">All</MenuItem>

                        {fringeData?.map((item, index) => (
                          <MenuItem key={index} sx={style.dropDownMenu} value={item?.name}>{item?.name}</MenuItem>
                        ))}
                      </Select>
                    </Box>
                  </Box>
                </Grid>
                {!isEmployeeRole && renderBulkFilters()}
              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!fringeFrom || !fringeTo || !fringe}
                  onClick={() => handleFringeReport(dayjs(fringeFrom).format("YYYY-MM-DD"), dayjs(fringeTo).format("YYYY-MM-DD"), fringe, "pdf", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!fringeFrom || !fringeTo || !fringe}
                  onClick={() => handleFringeReport(dayjs(fringeFrom).format("YYYY-MM-DD"), dayjs(fringeTo).format("YYYY-MM-DD"), fringe, "csv", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>

              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!fringeFrom || !fringeTo || !fringe}
                  onClick={() => handleFringeReport(dayjs(fringeFrom).format("YYYY-MM-DD"), dayjs(fringeTo).format("YYYY-MM-DD"), fringe, "excel", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>
              </Box>
            </Box>
          </Grid>
        </>
      )}
      {reportType === "Credit Report" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>Credit Report</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={creditFrom}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        maxDate={creditTo}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setCreditForm(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={creditTo}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          minDate={creditFrom}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setCreditTo(newValue); }}
                        />
                      </Box>
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>Credit</InputLabel>
                    <Box sx={style.selectGrid}>
                      <Select
                        value={credit}
                        onChange={(e) => { setCredit(e.target.value) }}
                        name="type"
                        sx={style.modalInput}
                        displayEmpty>
                        <MenuItem disabled value=""> Select </MenuItem>
                        <MenuItem sx={style.dropDownMenu} value="all">All</MenuItem>

                        {creditsType?.map((item, index) => (
                          <MenuItem key={index} sx={style.dropDownMenu} value={item?.name}>{item?.name}</MenuItem>
                        ))}
                      </Select>
                    </Box>
                  </Box>
                </Grid>
                {!isEmployeeRole && renderBulkFilters()}
              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!creditFrom || !creditTo || !credit}
                  onClick={() => handleCreditReport(dayjs(creditFrom).format("YYYY-MM-DD"), dayjs(creditTo).format("YYYY-MM-DD"), credit, "pdf", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!creditFrom || !creditTo || !credit}
                  onClick={() => handleCreditReport(dayjs(creditFrom).format("YYYY-MM-DD"), dayjs(creditTo).format("YYYY-MM-DD"), credit, "csv", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>

              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!creditFrom || !creditTo || !credit}
                  onClick={() => handleCreditReport(dayjs(creditFrom).format("YYYY-MM-DD"), dayjs(creditTo).format("YYYY-MM-DD"), credit, "excel", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>


              </Box>

            </Box>
          </Grid>
        </>
      )}
      {reportType === "Loan Report" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>Loan Report</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={loanFrom}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setLoanFrom(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={loanTo}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setLoanTo(newValue); }}
                          minDate={loanFrom}
                        />
                      </Box>
                    </LocalizationProvider>
                  </Box>
                </Grid>
                {!isEmployeeRole && renderBulkFilters()}
              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!loanFrom || !loanTo}
                  onClick={() => handleLoanReport(dayjs(loanFrom).format("YYYY-MM-DD"), dayjs(loanTo).format("YYYY-MM-DD"), "pdf", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!loanFrom || !loanTo}
                  onClick={() => handleLoanReport(dayjs(loanFrom).format("YYYY-MM-DD"), dayjs(loanTo).format("YYYY-MM-DD"), "csv", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>
              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!loanFrom || !loanTo}
                  onClick={() => handleLoanReport(dayjs(loanFrom).format("YYYY-MM-DD"), dayjs(loanTo).format("YYYY-MM-DD"), "excel", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>
              </Box>
            </Box>
          </Grid>
        </>
      )}
      {reportType === "Attendance Report" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>Attendance Report</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={attendanceFrom}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setAttendanceFrom(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={attendanceTo}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setAttendanceTo(newValue); }}
                          minDate={attendanceFrom}
                        />
                      </Box>
                    </LocalizationProvider>
                  </Box>
                </Grid>
                {!isEmployeeRole && renderBulkFilters()}
                <Grid container >
                  <Grid item xs={12} lg={4}>
                    <Box sx={style.toggleSection}>
                      <Typography sx={style.toggleLabel}>Include All Employees</Typography>
                      <AntSwitch
                        checked={includeAllEmployees}
                        onChange={(event) => setIncludeAllEmployees(event.target.checked)}
                        inputProps={{ "aria-label": "include all employees" }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!attendanceFrom || !attendanceTo}
                  onClick={() => handleAttendanceReport(dayjs(attendanceFrom).format("YYYY-MM-DD"), dayjs(attendanceTo).format("YYYY-MM-DD"), includeAllEmployees, "pdf", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!attendanceFrom || !attendanceTo}
                  onClick={() => handleAttendanceReport(dayjs(attendanceFrom).format("YYYY-MM-DD"), dayjs(attendanceTo).format("YYYY-MM-DD"), includeAllEmployees, "csv", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>

              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!attendanceFrom || !attendanceTo}
                  onClick={() => handleAttendanceReport(dayjs(attendanceFrom).format("YYYY-MM-DD"), dayjs(attendanceTo).format("YYYY-MM-DD"), includeAllEmployees, "excel", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>


              </Box>

            </Box>
          </Grid>
        </>
      )}
      {reportType === "Loan" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>Loan Report</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={attendanceFrom}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setAttendanceFrom(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={attendanceTo}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setAttendanceTo(newValue); }}
                          minDate={attendanceFrom}
                        />
                      </Box>
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid container >
                  <Grid item xs={12} lg={4}>
                    <Box sx={style.toggleSection}>
                      <Typography sx={style.toggleLabel}>Include All Employees</Typography>
                      <AntSwitch
                        checked={includeAllEmployees}
                        onChange={(event) => setIncludeAllEmployees(event.target.checked)}
                        inputProps={{ "aria-label": "include all employees" }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!attendanceFrom || !attendanceTo}
                  onClick={() => handleAttendanceReport(dayjs(attendanceFrom).format("YYYY-MM-DD"), dayjs(attendanceTo).format("YYYY-MM-DD"), includeAllEmployees, "pdf", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!attendanceFrom || !attendanceTo}
                  onClick={() => handleAttendanceReport(dayjs(attendanceFrom).format("YYYY-MM-DD"), dayjs(attendanceTo).format("YYYY-MM-DD"), includeAllEmployees, "csv", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>

              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!attendanceFrom || !attendanceTo}
                  onClick={() => handleAttendanceReport(dayjs(attendanceFrom).format("YYYY-MM-DD"), dayjs(attendanceTo).format("YYYY-MM-DD"), includeAllEmployees, "excel", bulkFilters)}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>


              </Box>

            </Box>
          </Grid>
        </>
      )}

      {reportType === "PAYE Report" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>{payeLabel} Report</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={payeFrom}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setPayeFrom(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={payeTo}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setPayeTo(newValue); }}
                          minDate={payeFrom}
                        />
                      </Box>
                    </LocalizationProvider>
                  </Box>
                </Grid>

              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!payeFrom || !payeTo}
                  onClick={() => handlePayeReport(dayjs(payeFrom).format("YYYY-MM-DD"), dayjs(payeTo).format("YYYY-MM-DD"), "pdf")}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!payeFrom || !payeTo}
                  onClick={() => handlePayeReport(dayjs(payeFrom).format("YYYY-MM-DD"), dayjs(payeTo).format("YYYY-MM-DD"), "csv")}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>

              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!payeFrom || !payeTo}
                  onClick={() => handlePayeReport(dayjs(payeFrom).format("YYYY-MM-DD"), dayjs(payeTo).format("YYYY-MM-DD"), "excel")}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>


              </Box>

            </Box>
          </Grid>
        </>
      )}

      {reportType === "UIF Report" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>UIF Report</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={uifFrom}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setUifFrom(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={uifTo}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setUifTo(newValue); }}
                          minDate={uifFrom}
                        />
                      </Box>
                    </LocalizationProvider>
                  </Box>
                </Grid>

              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!uifFrom || !uifTo}
                  onClick={() => handleUifReport(dayjs(uifFrom).format("YYYY-MM-DD"), dayjs(uifTo).format("YYYY-MM-DD"), "pdf")}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!uifFrom || !uifTo}
                  onClick={() => handleUifReport(dayjs(uifFrom).format("YYYY-MM-DD"), dayjs(uifTo).format("YYYY-MM-DD"), "csv")}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>

              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!uifFrom || !uifTo}
                  onClick={() => handleUifReport(dayjs(uifFrom).format("YYYY-MM-DD"), dayjs(uifTo).format("YYYY-MM-DD"), "excel")}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>


              </Box>

            </Box>
          </Grid>
        </>
      )}
      {reportType === "SDL Report" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>SDL Report</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={sdlFrom}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setSdlFrom(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={sdlTo}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setSdlTo(newValue); }}
                          minDate={sdlFrom}
                        />
                      </Box>
                    </LocalizationProvider>
                  </Box>
                </Grid>

              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!sdlFrom || !sdlTo}
                  onClick={() => handleSdlReport(dayjs(sdlFrom).format("YYYY-MM-DD"), dayjs(sdlTo).format("YYYY-MM-DD"), "pdf")}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!sdlFrom || !sdlTo}
                  onClick={() => handleSdlReport(dayjs(sdlFrom).format("YYYY-MM-DD"), dayjs(sdlTo).format("YYYY-MM-DD"), "csv")}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>

              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!sdlFrom || !sdlTo}
                  onClick={() => handleSdlReport(dayjs(sdlFrom).format("YYYY-MM-DD"), dayjs(sdlTo).format("YYYY-MM-DD"), "excel")}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>


              </Box>

            </Box>
          </Grid>
        </>
      )}
      {reportType === "Generalize Tax Report" && (
        <>
          <Box sx={style.typeGrid}>
            <Typography sx={style.gridText}>Generalize Tax Report</Typography>
          </Box>
          <Grid container sx={style.mainContainer}>
            <Grid item xs={12} lg={11.8} sx={style.gridbox}>
              <Grid container>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>From</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        value={generalStartDate}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }}
                        sx={style.calenderInput}
                        onChange={(newValue) => { setGeneralStartDate(newValue); }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <Box sx={style.inputSection}>
                    <InputLabel sx={style.labels}>To</InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Box>
                        <DatePicker
                          value={generalEndDate}
                          slotProps={{
                            field: {
                              readOnly: true
                            }
                          }}
                          sx={style.calenderInput}
                          onChange={(newValue) => { setGeneralEndDate(newValue); }}
                          minDate={sdlFrom}
                        />
                      </Box>
                    </LocalizationProvider>
                  </Box>
                </Grid>

              </Grid>
            </Grid>
            <Box sx={style.btnSection}>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!generalStartDate || !generalEndDate}
                  onClick={() => handleGeneralizeTax(dayjs(generalStartDate).format("YYYY-MM-DD"), dayjs(generalEndDate).format("YYYY-MM-DD"), "pdf")}
                  type="submit"
                  color="primary"
                  sx={style.submitPdf}
                >
                  Pdf
                </LoadingButton>
              </Box>
              <Box sx={style.btnGrid}>
                <LoadingButton
                  variant="contained"
                  disabled={!generalStartDate || !generalEndDate}
                  onClick={() => handleGeneralizeTax(dayjs(generalStartDate).format("YYYY-MM-DD"), dayjs(generalEndDate).format("YYYY-MM-DD"), "csv")}
                  type="submit"
                  color="primary"
                  sx={style.submitButton}
                >
                  CSV
                </LoadingButton>

              </Box>
              <Box sx={style.btnPdf}>
                <LoadingButton
                  variant="contained"
                  disabled={!generalStartDate || !generalEndDate}
                  onClick={() => handleGeneralizeTax(dayjs(generalStartDate).format("YYYY-MM-DD"), dayjs(generalEndDate).format("YYYY-MM-DD"), "excel")}
                  type="submit"
                  color="primary"
                  sx={style.submitexcel}
                >
                  Excel
                </LoadingButton>
              </Box>
            </Box>
          </Grid>
        </>
      )}

    </>

  )
}
export default Report;
